"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InvoiceType;
(function (InvoiceType) {
    InvoiceType["FIRM_BILLING"] = "Firm Billing";
    InvoiceType["FIRM_MEMBERSHIP"] = "Firm Membership";
    InvoiceType["B2C_MEMBERSHIP"] = "B2C Membership";
    InvoiceType["B2B_INVOICE"] = "B2B Invoice";
})(InvoiceType = exports.InvoiceType || (exports.InvoiceType = {}));
var SaleType;
(function (SaleType) {
    SaleType["FIRM_BILLING"] = "Firm Billing";
    SaleType["FIRM_MEMBERSHIP"] = "Firm Membership";
    SaleType["B2C_MEMBERSHIP"] = "B2C Membership";
    SaleType["B2B_INVOICE"] = "B2B Invoice";
    SaleType["BENEFIT_SELECTION"] = "Benefit Selection";
})(SaleType = exports.SaleType || (exports.SaleType = {}));
var TermType;
(function (TermType) {
    TermType["TERMED"] = "TERMED";
    TermType["EVERGREEN"] = "EVERGREEN";
})(TermType = exports.TermType || (exports.TermType = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["EXTERNAL"] = "External";
    PaymentType["ELECTRONIC"] = "Electronic";
})(PaymentType = exports.PaymentType || (exports.PaymentType = {}));
var PaymentOption;
(function (PaymentOption) {
    PaymentOption["REGULAR"] = "REGULAR";
    PaymentOption["NO_PAYMENT"] = "NO_PAYMENT";
    PaymentOption["OFFLINE"] = "OFFLINE";
    PaymentOption["CHECK"] = "CHECK";
    PaymentOption["REFUND"] = "REFUND";
})(PaymentOption = exports.PaymentOption || (exports.PaymentOption = {}));
//# sourceMappingURL=transactions.js.map